goog.provide('el8.data.practices');

goog.require('el8.model.base');


el8.data.practices = (function() {
    var _class = function(spec) { 
        this.populate(spec); 

        // These are manually defined properties instead of Booleans, because
        // we want to be able to distinguish between null and false.
        // In the former case, we'll make a synchronous request to check on integrations.
        this._kareoIntegrated = null;
        this._pmsIntegrated = null;
        this._integrations = null;
    };

    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('name', true);
    _class.addBoolean('patient', true); // true if this is a "patient" practice
    _class.addBoolean('practicingEmr', true); // true if this is a "patient" practice
    _class.addStringProperty('tzLocale', true);

    _class.addIntProperty('enterpriseId', false);
    _class.addStringProperty('enterpriseName', false);

    _class.addStringProperty('phone', true);
    _class.addStringProperty('fax', true);

    _class.addStringProperty('address', true);
    _class.addStringProperty('suite', true);
    _class.addStringProperty('city', true);
    _class.addStringProperty('state', true);
    _class.addStringProperty('zip', true);
    _class.addStringProperty('addressLine', true);
    _class.addStringProperty('cityStateZip', true);

    // APIv2 applications
    _class.addProperty('applications', true, []);


    _class.prototype.ensureAPIIntegrationData = function() {
        // Checks to see whether we've fetched the _kareoIntegrated 
        // and _pmsIntegrated flags, and fetches them if we haven't
        var practice = this;
        if (practice._kareoIntegrated === null || practice._pmsIntegrated === null) {
            $.el8_ajax({
                type: 'GET',
                url: '/api-integrations/',
                async: false,
                success: function(data) {
                    practice._kareoIntegrated = data.kareo_integrated;
                    practice._pmsIntegrated = data.pms_integrated;
                    practice._integrations = data.integrations;
                }
            });
        }
    };

    _class.prototype.fetchApplications = function(cb) {
        var practice = this;

        if (_.isEmpty(practice.getApplications())) {
            $.el8_ajax({
                type: 'GET',
                url: '/practice/'+practice.getId()+'/application/',
                async: false,
                success: function(data) {
                    practice.setApplications(data);
                    cb(data);
                }
            });

        }
    };

    _class.prototype.isKareoIntegrated = function() {
        var practice = this;
        practice.ensureAPIIntegrationData();
        return practice._kareoIntegrated;
    };

    _class.prototype.isPMSIntegrated = function() {
        // Specifically used to decide whether to show the "Send bill early"
        // functionality
        var practice = this;
        practice.ensureAPIIntegrationData();
        return practice._pmsIntegrated;
    };
    
    _class.prototype.hasIntegration = function() {
        var practice = this;
        practice.ensureAPIIntegrationData();
        return practice._integrations && practice._integrations.length > 0;
    };

    return new el8_EntitySet({model: function(spec) { return new _class(spec); }});

})();


